<template>
    <div id="ticket" class="page">
        
        <div class="row">
            <div class="col-12" style="display:flex; justify-content:center;">
                <!-- <img style="width:250px;" src="@/lobato/general/img/logo-3.jpg" alt=""> -->
                <p>Compra y venta de metales</p>
            </div>

            <div class="col-12" v-if="![null,''].includes(datos.ticket.no)">
                <label for="inputEmail4" style="margin-bottom:0px !important;">
                    <span style="font-weight:bold;">
                        COMPRA
                    </span>: 
                    {{datos.ticket.no}}
                </label>                                    
            </div>
            <div class="col-6">
                <label for="inputEmail4" style="margin-bottom:0px !important;">{{datos.ticket.fecha_creacion}}</label>                                    
            </div>
            <div class="col-6">
                <label for="inputEmail4" style="margin-bottom:0px !important;">{{datos.ticket.hora_creacion}}</label>                                    
            </div>
            <div class="col-12">
                <label for="inputEmail4" style="margin-bottom:0px !important;">
                    <span style="font-weight:bold;">CLIENTE</span>: 
                    {{datos.ticket.cliente_nombre}} 
                    {{datos.ticket.cliente_apellido_paterno}}
                    {{datos.ticket.cliente_apellido_materno}}
                </label>                                    
            </div>
            <div class="col-12">
                <p id="titulo-tabla-materiales">MATERIALES</p>
                <table class="table" style="font-size:0.5em;">
                    
                    <thead style="border-top:2px solid black;">
                        <tr>
                            <!-- <th scope="col">#</th> -->
                            <th scope="col" width="10">Cant.</th>
                            <th scope="col" width="40">Descripción</th>
                            <th scope="col" width="25">Precio</th>
                            <th scope="col" width="25">Importe</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for='(p,p_index) in datos.ticket.productos' :key=p_index>
                            <!-- <th scope="row">{{p_index+1}}</th> -->
                            <td>{{ p.cantidad }}</td>
                            <td style="word-wrap: break-word;">{{ p.producto_nombre }}</td>
                            <td style="word-wrap: break-word;">{{ formato_moneda(p.precio) }}</td>
                            <td style="word-wrap: break-word;">{{ formato_moneda(p.total) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="col-12">            
                <p id="total-ticket" style="text-align:center; margin:0px;">
                    Total materiales {{ formato_moneda(datos.ticket.total_materiales) }}
                </p>
            </div>

            <template v-if="(datos.ticket.prestamos).length>0">
                <div class="col-12">
                    <p id="titulo-tabla-prestamos">Prestamos</p>
                    <table class="table" style="font-size:0.5em;">
                        
                        <thead>
                            <tr>
                                <th style="width:25%;"></th>
                                <th style="width:25%;" scope="col">Prestamo</th>
                                <th style="width:25%;"></th>
                                <th style="width:25%;" scope="col">Abono</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for='(p,p_index) in datos.ticket.prestamos' :key=p_index>                            
                                <td></td>
                                <td>{{ formato_moneda(p.cantidad) }}</td>
                                <td></td>
                                <td>{{ formato_moneda(p.abono) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="col-12">            
                    <p id="total-ticket" style="text-align:center; margin:0px;">
                        Total prestamos {{ formato_moneda(datos.ticket.total_prestamos) }}
                    </p>
                </div>
            </template>



            <div class="col-12">            
                <p id="total-final-ticket" style="text-align:center; margin:0px;">
                    Total final {{ formato_moneda(datos.ticket.total_compra) }}
                </p>
            </div>

        </div>

    </div>
</template>
<script>
/* eslint-disable */
import { watch } from 'vue';
import { useRoute } from 'vue-router';

import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
import * as calculos  from '@/librerias/lobato-calculos.js'
import PouchDB  from '@/librerias/pouchdb/pouchdb.min.js'

//import html2canvas from 'html2canvas'

export default {
    name: 'com_general',
    props: {
        msg: String
    },
    data() {
        return {
            datos:{
                compras_id:this.$route.params.id,
                ticket:{
                    no:'',
                    total_materiales:0,
                    total_prestamos:0,
                    total_compra:'',

                    fecha_creacion:'',  
                    hora_creacion:'',                  
                    cliente_nombre:'',
                    cliente_apellido_paterno:'',
                    cliente_apellido_materno:'',
                    productos:[],
                    prestamos:[]
                }            
            }
        }
    },
    mounted(){
        this.inicial();
    },
    methods:{
        ...mapMutations(['funciones','alerta']),  
         inicial()
        {
            const routerView = this.$el;
            document.body.innerHTML = '';
            document.body.appendChild(routerView);                  
            this.obtener_datos();                                  
        },
        obtener_datos()
        {
            console.log('id ');
            //this.datos.compras_id=(this.datos.compras_id).replace('local_','');
            console.log(this.datos.compras_id);


            //if(this.general.otros.app_modo=='online')
            if((this.datos.compras_id).includes('local_'))
            {

                console.log('_id es');
                this.datos.compras_id=(this.datos.compras_id).replace('local_','');
                console.log(this.datos.compras_id);

                fetch(`${this.general.otros.dominio_server}/compras/recursos`,{
                    method:'GET',
                    //body:JSON.stringify( this.datos.registro ),
                    headers:{
                        'Accept'        :'application/json',
                        'Content-Type'  :'application/json',
                        //'Authorization' :`Bearer ${this.general.otros.token}`
                        //'X-CSRF-TOKEN':this.general.otros.csrf
                    },
                    credentials: 'include',                   
                })
                .then(res=>res.json())
                .then(respuesta=>{
                    
                    console.log('recursos');
                    console.log(respuesta);

                    let cli=respuesta.datos.clientes;
                    let pro=respuesta.datos.productos;

                    let db = new PouchDB('metales_milenio_2024_compras');
                    db.get(this.datos.compras_id)
                    .then( (doc) => {
                        console.log('datos son');
                        console.log(doc);

                        
                        //this.datos.ticket.no='';
                        this.datos.ticket.total_materiales  =doc.total_compra;
                        //this.datos.ticket.total_prestamos:0,
                        this.datos.ticket.total_compra      =doc.total_compra;

                        this.datos.ticket.fecha_creacion=doc.fecha_creacion;  
                        //this.datos.ticket.hora_creacion:'',  
                        let c=cli.find((e)=>e.id==doc.clientes_id);
                        if(c!==undefined)
                        {   
                            c.nombre            =['',null].includes(c.nombre) ? '' : c.nombre;
                            c.apellido_paterno  =['',null].includes(c.apellido_paterno) ? '' : c.apellido_paterno;
                            c.apellido_materno  =['',null].includes(c.apellido_materno) ? '' : c.apellido_materno;

                            this.datos.ticket.cliente_nombre            =c.nombre;
                            this.datos.ticket.cliente_apellido_paterno  =c.apellido_paterno;
                            this.datos.ticket.cliente_apellido_materno  =c.apellido_materno;
                        }                       

                        doc.productos.forEach((item,index)=>{

                            let p=pro.find((e)=>e.id==item.productos_id);

                            this.datos.ticket.productos.push({
                                cantidad        :item.cantidad,
                                producto_nombre :p==undefined ? '' : p.nombre,
                                precio          :item.precio,
                                total           :item.total
                            });

                        });
                        setTimeout(() => {
                            //console.log("Retrasado por 3 segundo.");
                            //this.generar_imagen();
                            window.print();
                        }, "2000");
                        //this.datos.ticket.productos:[],
                        //this.datos.ticket.prestamos:[] */

                    });

                })
                .catch(error=>{
                    this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los recursos`});
                })
                .finally( () => {
                    //this.datos.data_table.cargando=false;                
                }); 

                
            }
            else
            {
                fetch(`${this.general.otros.dominio_server}/compras/${this.datos.compras_id}/ticket/datos`,{
                    method:'GET',
                    headers:{
                        'Accept'        :'application/json',
                        'Content-Type'  :'application/json',
                        //'Authorization' :`Bearer ${this.general.otros.token}`
                        //'X-CSRF-TOKEN':this.general.otros.csrf
                    },
                    credentials: 'include',                   
                })
                .then(res=>res.json())
                .then(respuesta=>{
                    console.log('datos : ');
                    console.log(respuesta);
                    if(respuesta.datos.compra.length>0)
                    {
                        let r=respuesta.datos.compra[0];
                        for (const p in this.datos.ticket) {                    
                            if(p=='productos')
                            {
                                this.datos.ticket[p]=p in r ? r[p] : [];

                                this.datos.ticket[p].forEach((item,index)=>{
                                    this.datos.ticket.total_materiales=calculos.calcular_suma([
                                        this.datos.ticket.total_materiales,
                                        item.total
                                    ]);                               
                                });
                            }
                            else if(p=='prestamos')
                            {
                                this.datos.ticket[p]=p in r ? r[p] : [];
                                this.datos.ticket[p].forEach((item,index)=>{
                                    this.datos.ticket.total_prestamos=calculos.calcular_suma([
                                        this.datos.ticket.total_prestamos,
                                        item.abono
                                    ]);                                
                                });
                            }
                            else
                            {
                                this.datos.ticket[p]=p in r ? r[p] : this.datos.ticket[p];
                            }
                        }
                        setTimeout(() => {
                            //console.log("Retrasado por 3 segundo.");
                            //this.generar_imagen();
                            window.print();
                        }, "2000");

                    }
                    //console.log('- datos son :');
                    //console.log(this.datos.ticket);
                })
                .catch(error=>{
                    this.funciones({nombre:'alerta',estatus:'error',mensaje:`No pudo obtenerse los datos`});
                })
                .finally( () => {
                    //this.datos.data_table.cargando=false;                
                });                               

            }
            
        },
        formato_moneda(m)
        {
            m=calculos.revisar_numero(m);
            return (m).toLocaleString("es-MX",{
                style: 'currency',
                currency: 'MXN'
            });
        },
        generar_imagen()
        {
            html2canvas(document.getElementById('ticket'))
            .then(canvas => { 
                //let img = canvas.toDataURL("image/png");
                canvas.toBlob(blob => { 
                    let img = URL.createObjectURL(blob); 
                    console.log('captura 3');
                    console.log(img);

                },"image/png");
            });

            /*html2canvas(document.getElementById('ticket'))
            .then(function(canvas) { 
                let imageData = canvas.toDataURL("image/png");
                console.log('captura');
                console.log(imageData); // Aquí puedes usar imageData según necesites
            });*/
        }
    },


    



    computed: {...mapState(['general']) },
}
</script>

<style lang="scss" scoped>

    #titulo-tabla-materiales{
        text-align:center;
        font-size:1rem;
        margin:0px;
    }
    #titulo-tabla-prestamos{
        text-align:center;
        font-size:0.7em;
        margin:0px;
    }
    #total-ticket{
        text-align:center;
        font-size:1rem !important;
        font-weight:800 !important;
        margin:0px;
    }

    #total-final-ticket{
        text-align:center;
        font-size:1rem !important;
        font-weight:800 !important;
        margin:0px;
    }


    #ticket{
        label{
            font-size:1rem;
            text-align:left;
            width:100%;
        }
        
    }
    
    

/*GENERAL*/

* {
	box-sizing: border-box;
	-moz-box-sizing: border-box;
}


.page{
	//width:	21.59cm !important;
    width:5.5cm !important;
	//height:	27.94cm;
	/*min-height:	29.7cm;*/
	//padding: 1.1cm !important;
    padding:0em;
	margin: 1cm auto !important;
	border: 1px #D3D3D3 solid !important;
	border-radius: 5px !important;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.1) !important;
    background:white;
}
.title-pre-catalogo {
	font-size: 15px;
	font-weight: bold;
	color:black;
	margin-top: 20px;
	margin-bottom: 0px;
}
.catego-expo{
	margin-top: 20px; 
	border-top: solid black 2px; 
	border-bottom: dashed black 1px; 
	padding: 10px 0;
}
.tabla-categoria-exposicion{
	margin-top: 20px; 
}
table.table.table-rounded.table-os{
	margin-bottom:0;
}

    .table th, .table td{
        font-weight:700 !important;
        font-size:0.6rem !important;

    }

    table tr th, table tr td{
        padding: 0px !important;

    }


@page { 
	size: letter;
	margin: 0;
} 
@media print { 

    label{
        font-weight:800 !important;
    }

    body{
        font-size:1rem !important;
        font-weight:800 !important;
        padding:0px !important;
        margin:0px !important;
    }

    .table th, .table td{
        font-weight:bold !important;
        font-size:0.95rem !important;
    }

    table tr th, table tr td{
        padding: 0px !important;
        border-bottom:2px solid black;
    }



	#ticket { 
		margin: 0;         
		padding: 0cm !important;
		border: initial !important; 
		border-radius: initial !important;  
		width: 6.6cm !important; 
		min-height: initial !important; 
		box-shadow: initial !important; 
		page-break-after: always !important; 
        margin:0px !important;
        /* background-color:blue !important; */
	}
	.bc-cotizacion{
		background: #4472c4;
	  	font-size: 20px;
	  	height: 30px;
	  	text-align: center;
	}
	.bc-cotizacion-equipos{
		background: #4472c4;
	  	font-size: 12px;
	  	text-align: center;
	}
	.bc-cotizacion-equipos td{
		padding: 2px 1px;
	}
	@page {
		size: portrait;
        padding:0px !important;
        margin:0px !important;
	}
}

@media screen {
  /* Contenido del fichero home.css */
}
/*.color-amcc{
	color: #2f3d79;
}*/
.img-center{
	display: block;
	margin: auto;
}

.fotos{
	page-break-inside: avoid;
}

</style>